<template>
  <section>
    <article
      ref="content"
      class="main-content editor__content"
      v-html="content"
    />
  </section>
</template>

<script>
import { inject } from '@vue/composition-api'
import extendContent from '@/utils/contentExtender'

export default {
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  setup () {
    const effectiveDatesRange = inject('effectiveDatesRange', '')
    const revisionChangeIteration = inject('revisionChangeIteration', 0)

    return {
      effectiveDatesRange,
      revisionChangeIteration,
    }
  },
  watch: {
    content () {
      this.enrichContent()
    },
    revisionChangeIteration () {
      this.enrichContent()
    },
  },
  mounted () {
    this.enrichContent()
  },
  methods: {
    enrichContent () {
      this.$nextTick(() => {
        extendContent(this.$refs.content, {
          vm: this,
        })
      })
    },
  },
}
</script>

<style lang="scss" src="@/css/editor_content.scss"></style>
